/* CO - Área de membros: "Detalhes da peça"

   Botões com [data-conso-detalhes="<handle>"] (montados pelo conso-area-brinde.js)
   abrem uma popup — tela inteira no mobile, janela grande no desktop — com a
   galeria, o acordeão de descrição e o "Bloco 3 imagens" da PDP.

   Sob demanda: nada é carregado até o clique (ou o toque, que já pré-busca). O HTML
   vem de templates/product.detalhes.json (sem layout: só as sections), em
   /products/<handle>?view=detalhes&variant=<id>, e fica em cache por produto+cor.

   Os componentes do Horizon (galeria, zoom, acordeão) se ligam sozinhos ao entrar
   no DOM; os <script> do HTML são recriados pra rodar (innerHTML não executa). A
   galeria filtra pela cor: `data-initial-variant-id` na <media-gallery> + um input
   name="id" no escopo da section, que é onde o filtro (snippets/conso-variant-gallery)
   procura a variante.

   Swatches de cor abaixo da galeria (topo da coluna de detalhes — no mobile fica logo
   embaixo da galeria): trocar a cor busca a mesma view na outra variante. A escolha
   aqui é só pra ver; não mexe na seleção do card. */
(function () {
  if (window.__consoAreaDetalhes) return;
  window.__consoAreaDetalhes = true;

  var cache = {};
  var dlg, corpo, titulo;
  var estado = null; /* { handle, variante, cor, titulo, sessao, cores[] } */
  var pedido = 0;

  function raiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function doBotao(b) {
    var cores = [];
    try { cores = JSON.parse(b.getAttribute('data-conso-detalhes-cores') || '[]'); } catch (e) { cores = []; }
    return {
      handle: b.getAttribute('data-conso-detalhes'),
      variante: b.getAttribute('data-conso-detalhes-variante') || '',
      cor: b.getAttribute('data-conso-detalhes-cor') || '',
      titulo: b.getAttribute('data-conso-detalhes-titulo') || '',
      sessao: b.getAttribute('data-conso-detalhes-sessao') || '',
      cores: cores
    };
  }

  function buscar(e) {
    var k = e.handle + '|' + e.variante;
    if (!cache[k]) {
      var url = raiz() + 'products/' + encodeURIComponent(e.handle) +
        '?view=detalhes' + (e.variante ? '&variant=' + encodeURIComponent(e.variante) : '');
      cache[k] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .catch(function (err) {
          delete cache[k];
          throw err;
        });
    }
    return cache[k];
  }

  function montar() {
    dlg = document.createElement('dialog');
    dlg.className = 'conso-area-detalhes';
    dlg.setAttribute('aria-labelledby', 'conso-area-detalhes-titulo');
    dlg.innerHTML =
      '<div class="conso-area-detalhes__topo">' +
      '<p class="conso-area-detalhes__titulo" id="conso-area-detalhes-titulo"></p>' +
      '<button type="button" class="conso-area-detalhes__fechar" aria-label="Fechar">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
      '</button></div>' +
      '<div class="conso-area-detalhes__corpo"></div>';
    document.body.appendChild(dlg);
    corpo = dlg.querySelector('.conso-area-detalhes__corpo');
    titulo = dlg.querySelector('.conso-area-detalhes__titulo');
    dlg.querySelector('.conso-area-detalhes__fechar').addEventListener('click', function () { dlg.close(); });
    /* clique no fundo (fora da caixa) fecha — só faz diferença no desktop */
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('conso-area-detalhes-aberta');
      corpo.innerHTML = ''; /* para vídeo e solta a memória da galeria */
      estado = null;
      pedido++;
    });
  }

  function swatches() {
    if (!estado || estado.cores.length < 2) return null;
    var box = document.createElement('div');
    box.className = 'conso-area-detalhes__cores';
    var rot = document.createElement('p');
    rot.className = 'conso-area-detalhes__cores-rotulo';
    rot.appendChild(document.createTextNode('Cor: '));
    var nome = document.createElement('strong');
    nome.textContent = estado.cor;
    rot.appendChild(nome);
    box.appendChild(rot);
    var lista = document.createElement('div');
    lista.className = 'conso-area-detalhes__cores-lista';
    lista.setAttribute('role', 'radiogroup');
    lista.setAttribute('aria-label', 'Cor');
    estado.cores.forEach(function (c) {
      if (!c.v) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'conso-area-detalhes__cor';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', c.n === estado.cor ? 'true' : 'false');
      b.setAttribute('aria-label', c.n);
      b.title = c.n;
      var bola = document.createElement('span');
      bola.className = 'conso-area-detalhes__cor-bola';
      if (c.s) bola.style.background = c.s;
      b.appendChild(bola);
      b.addEventListener('click', function () { trocarCor(c); });
      /* pré-busca a outra cor no toque/hover */
      ['pointerdown', 'mouseenter'].forEach(function (ev) {
        b.addEventListener(ev, function () {
          buscar({ handle: estado.handle, variante: c.v }).catch(function () {});
        }, { passive: true });
      });
      lista.appendChild(b);
    });
    box.appendChild(lista);
    return box;
  }

  function injetar(html) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var frag = tpl.content;
    frag.querySelectorAll('script[type="application/ld+json"]').forEach(function (s) { s.remove(); });

    var v = estado.variante;
    if (v) {
      frag.querySelectorAll('media-gallery').forEach(function (g) { g.setAttribute('data-initial-variant-id', v); });
      var sec = frag.querySelector('.shopify-section');
      if (sec) {
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'id';
        inp.value = v;
        sec.prepend(inp);
      }
    }

    /* Descrição (primeiro item do acordeão) aberta no desktop. O <accordion-custom>
       do tema decide o estado inicial pelo atributo, não pelo `open` do <details>. */
    var primeiro = frag.querySelector('accordion-custom');
    if (primeiro) primeiro.setAttribute('open-by-default-on-desktop', '');

    var sw = swatches();
    if (sw) {
      /* antes do bloco do acordeão, na mesma coluna (o .product-details em si é
         flex em linha: no topo dele as bolinhas ficavam AO LADO do acordeão) */
      var ac = frag.querySelector('accordion-custom');
      var bloco = ac && (ac.closest('.accordion') || ac);
      if (bloco && bloco.parentNode) bloco.parentNode.insertBefore(sw, bloco);
      else {
        var g = frag.querySelector('media-gallery');
        if (g && g.parentNode) g.parentNode.insertBefore(sw, g.nextSibling);
      }
    }

    corpo.innerHTML = '';
    corpo.appendChild(frag);

    corpo.querySelectorAll('script').forEach(function (s) {
      var t = (s.getAttribute('type') || '').trim();
      if (t && t !== 'text/javascript' && t !== 'module') return; /* JSON (mapa de cores) fica como dado */
      var n = document.createElement('script');
      Array.prototype.forEach.call(s.attributes, function (a) { n.setAttribute(a.name, a.value); });
      n.textContent = s.textContent;
      s.replaceWith(n);
    });
  }

  function erro() {
    corpo.innerHTML = '';
    var p = document.createElement('p');
    p.className = 'conso-area-detalhes__erro';
    p.textContent = 'Não foi possível carregar os detalhes agora. ';
    var a = document.createElement('a');
    a.href = raiz() + 'products/' + estado.handle;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = 'Ver a página da peça';
    p.appendChild(a);
    corpo.appendChild(p);
  }

  function carregar(manterRolagem) {
    var meu = ++pedido;
    var rolagem = manterRolagem ? corpo.scrollTop : 0;
    if (!manterRolagem) {
      corpo.innerHTML = '<div class="conso-area-detalhes__carregando" role="status" aria-label="Carregando"></div>';
      corpo.scrollTop = 0;
    } else {
      corpo.classList.add('is-trocando');
    }
    buscar(estado).then(function (html) {
      if (meu !== pedido || !dlg.open) return;
      injetar(html);
      corpo.classList.remove('is-trocando');
      corpo.scrollTop = rolagem;
    }).catch(function () {
      if (meu !== pedido || !dlg.open) return;
      corpo.classList.remove('is-trocando');
      erro();
    });
  }

  function trocarCor(c) {
    if (!estado || c.n === estado.cor) return;
    estado.cor = c.n;
    estado.variante = c.v;
    corpo.querySelectorAll('.conso-area-detalhes__cor').forEach(function (b) {
      b.setAttribute('aria-checked', b.title === c.n ? 'true' : 'false');
    });
    var nome = corpo.querySelector('.conso-area-detalhes__cores-rotulo strong');
    if (nome) nome.textContent = c.n;
    carregar(true);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'conso_area_detalhes_cor', area_sessao: estado.sessao, area_produto: estado.handle, area_cor: c.n });
  }

  function abrir(b) {
    if (!dlg) montar();
    estado = doBotao(b);
    titulo.textContent = estado.titulo;
    document.documentElement.classList.add('conso-area-detalhes-aberta');
    dlg.showModal();
    carregar(false);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'conso_area_detalhes', area_sessao: estado.sessao, area_produto: estado.handle });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-conso-detalhes]');
    if (!b) return;
    e.preventDefault();
    abrir(b);
  });

  /* pré-busca no toque/hover: ganha o tempo entre encostar e soltar */
  ['pointerdown', 'mouseover'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var b = e.target.closest && e.target.closest('[data-conso-detalhes]');
      if (b) buscar(doBotao(b)).catch(function () {});
    }, { passive: true });
  });
})();
